import React, {useContext, useEffect} from 'react'
import {ReservationContext} from '../../../context/Reservation'
import {ListItem, Typography} from '@material-ui/core'
import './ReservedForValues.styles.scss'
import LoadingIndicator from '../../ReservationConfiguration/LoadingIcon'
import _ from 'lodash'
export default function ReservedForFieldValues({setPopAnchor, selectedField, search}) {
  const {reservation, reservedForFieldValues, loadReservedForFieldValues, update} = useContext(
    ReservationContext
  )

  useEffect(() => {
    if (!_.isEmpty(selectedField)) {
      const field_ids = (selectedField?.field_details || []).map(f => f.field_id)
      loadReservedForFieldValues(field_ids, selectedField.field_type, search)
    }
  }, [loadReservedForFieldValues, selectedField, search])

  const handleClickValue = (e, value) => {
    setPopAnchor(null)
    update('reserved_for', {name: value.name, id: value.id})
    // only update field upon selection of reserved_for
    update('reserve_for_field', selectedField)
  }

  return (
    <div>
      {reservedForFieldValues.data?.data?.length === 0 && !reservedForFieldValues.isLoading && (
        <div
          className="ap-typography ap-typography--xs ap-typography--nowrap"
          style={{padding: '8px 4px', textAlign: 'center'}}
        >
          No results found.
        </div>
      )}

      {!!selectedField &&
      reservedForFieldValues &&
      !reservedForFieldValues.isLoading &&
      reservedForFieldValues.data.data
        ? reservedForFieldValues.data.data.map(fv => {
            return (
              <ListItem
                style={{cursor: 'pointer'}}
                onClick={e => handleClickValue(e, fv)}
                className={
                  fv.name === reservation.reserved_for.value
                    ? 'selected-field-value'
                    : 'reserved-for-value'
                }
              >
                <Typography className="ap-typography ap-typography--sm ap-ellipsis">
                  {fv.name}
                </Typography>
              </ListItem>
            )
          })
        : reservedForFieldValues.isLoading && <LoadingIndicator style={{width: '100%'}} />}
    </div>
  )
}
